import { Badge, Button, Form, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../store'
import { toggleTestMode } from '../../store/institution/institution'

function TestModeIndicator() {
  const dispatch = useDispatch()
  const {
    data: { authenticated }, testMode
  } = useSelector((state: RootState) => state.institution)
  const {
    data: { use_workflow },
  } = useSelector((state: RootState) => state.program)
  const handleClick = () => {
    dispatch(toggleTestMode())
  }

  const helpText =
    'Testmodus: ' +
    (use_workflow ? 'Hier können Sie Veranstaltungen in allen Workflow-Status sehen. ' : '') +
    'Sie können alle Veranstaltungen auswählen auch wenn diese für Teilnehmer nicht auswählbar wären!'
  return (
    <>
      { authenticated && (
        <Nav.Item role={'button'}>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">{helpText}</Tooltip>}
          >
            <Button onClick={handleClick} variant={testMode ? 'outline-warning' : 'outline-secondary'}
            >
              <FontAwesomeIcon icon={'warning'}/> Testmodus: { testMode ? "An" : "Aus"}
            </Button>
          </OverlayTrigger>
        </Nav.Item>
      )}
    </>
  )
}

export default TestModeIndicator
